"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSettingsListContainer = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable new-cap */
/* eslint-disable no-unused-vars */
const react_1 = tslib_1.__importStar(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const core_1 = require("@dnd-kit/core");
const sortable_1 = require("@dnd-kit/sortable");
const modifiers_1 = require("@dnd-kit/modifiers");
const TableSettingsListItem_1 = tslib_1.__importDefault(require("./TableSettingsListItem"));
const TableSettingsListContainer = props => {
    const { items, onSortEnd, itemProps } = props;
    const [activeDraggedColumn, setActiveDraggedColumn] = (0, react_1.useState)(null);
    const sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.PointerSensor), (0, core_1.useSensor)(core_1.KeyboardSensor, {
        coordinateGetter: sortable_1.sortableKeyboardCoordinates,
    }));
    const handleDragStart = (0, react_1.useCallback)(event => {
        setActiveDraggedColumn(event.active.id);
    }, []);
    const handleDragEnd = (0, react_1.useCallback)(event => {
        setActiveDraggedColumn(null);
        onSortEnd(event);
    }, []);
    const activeClass = 'table-settings-item shadow-smooth-to-bottom z-index-max';
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'table-settings-items-container' }, { children: (0, jsx_runtime_1.jsx)(core_1.DndContext, Object.assign({ modifiers: [modifiers_1.restrictToVerticalAxis], onDragStart: handleDragStart, onDragEnd: handleDragEnd }, { children: (0, jsx_runtime_1.jsx)(sortable_1.SortableContext, Object.assign({ items: items, sensors: sensors, collisionDetection: core_1.closestCenter, strategy: sortable_1.rectSortingStrategy }, { children: items.map((column, index) => ((0, jsx_runtime_1.jsx)(TableSettingsListItem_1.default, Object.assign({ index: index, column: column, orderIndex: index, className: activeDraggedColumn === column ? activeClass : '' }, itemProps), column))) })) })) })));
};
exports.TableSettingsListContainer = TableSettingsListContainer;
exports.TableSettingsListContainer.propTypes = {
    items: prop_types_1.default.arrayOf(prop_types_1.default.string),
    onSortEnd: prop_types_1.default.func,
    itemProps: prop_types_1.default.object,
};
